// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PReconciliationOutlinedSvg from "@fishx/icons-svg/es/asn/PReconciliationOutlined";
import FishxIcon from '../components/FishxIcon';

var PReconciliationOutlined = function PReconciliationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PReconciliationOutlinedSvg
  }));
};

PReconciliationOutlined.displayName = 'PReconciliationOutlined';
export default React.forwardRef(PReconciliationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PReconciliationOutlined.js
// module id = 3579
// module chunks = 0